








































































import { Component, Vue } from 'vue-property-decorator';
import BillEditor, { BillEditType } from '@/components/bill/billEditor.vue';
import Axios from 'axios';
import { Route } from 'vue-router';
import { BillItemGroup, BillSettings, BillTemplate } from '@/models/billData';
import { BillTypes } from '@/enums/billTypes';
import { BillTemplateResponse } from '@/models/billTemplateResponse';
import { TaxTypes } from '@/enums/taxTypes';
import { BillItemsResponse } from '@/models/billItemResponse';
import { BillTemplateRequest } from '@/models/billTemplateRequest';
import { ElForm } from 'node_modules/element-ui/types/form';
import { getGradeYearName, GradeYears } from '@/enums/gradeYears';
import { BillStatusTypes } from '@/enums/billStatusTypes';
import { PaymentStatusTypes } from '@/enums/paymentStatusTypes';
import AvaivaledVue from '@/components/avaivaled.vue';
import { FunctionTypes } from '@/enums/functionTypes';
import { CollectionAgencyTypes } from '@/enums/collectionAgencyTypes';

@Component({
  components: {
    BillEditor,
  }
})
export default class BillTemplateEdit extends AvaivaledVue {

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  get isEdit() {
      return !!this.$route.params.billTemplateId;
  }

  get pageTitle() {
    return this.isEdit
      ? '請求書テンプレート編集'
      : '請求書テンプレート登録';
  }

  get billSettings(): BillSettings {
    return this.$store.state.bill.billSettings;
  }

  get billItemGroups(): BillItemGroup[] {
    return this.$store.state.bill.billItemGroups;
  }

  get collectionAgency(): CollectionAgencyTypes {
    if (!this.user || !this.user.collectionAgency) {
      return CollectionAgencyTypes.None;
    }
    return this.user.collectionAgency;
  }

  public BillEditType = BillEditType;

  public getGradeYearName = getGradeYearName;

  public BillTypes = BillTypes;
  public TaxTypes = TaxTypes;

  public loaded: boolean = false;
  public billTemplateData: BillTemplate | null = null;

  public async created() {
    const ok = await this.pageBackCheck(FunctionTypes.Bill);
    if (!ok) {
      return;
    }

    try {
      await this.$store.dispatch('bill/fetchBillSettings');
      await this.$store.dispatch('bill/fetchBillItems');
    } catch (error) {
      //
    }

    if (!this.billTemplateData) {
      try {
        const billTemplateId = this.$route.params.billTemplateId;
        if (billTemplateId) {
          const res = await Axios.get<BillTemplateResponse>(`/api/bill-templates/${billTemplateId}`);
          const resData = res.data;
          this.billTemplateData = {
            billId: resData.billTemplateId,
            templateName: resData.templateName,
            studentId: '',
            studentUserId: '',
            studentName: '(生徒氏名)',
            gradeYear: GradeYears.ElementarySchool1,
            billGradeYear: GradeYears.ElementarySchool1,
            title: resData.title,
            billNo: '',
            billDate: null,
            billDateCreationMonth: resData.billDateCreationMonth,
            billDateCreationDay: resData.billDateCreationDay,
            billMessage: resData.billMessage,
            contactInfo: resData.contactInfo,
            billType: resData.billType,
            billExplanation: resData.billExplanation,
            billLimitDate: null,
            billLimitDateCreationMonth: resData.billLimitDateCreationMonth,
            billLimitDateCreationDay: resData.billLimitDateCreationDay,
            taxRate: resData.taxRate,
            taxType: this.billSettings.taxType,
            taxRoundType: this.billSettings.taxRoundType,
            billStatus: BillStatusTypes.Unbilled,
            billStatusUpdatedAt: null,
            paymentStatus: PaymentStatusTypes.Unpaid,
            paymentStatusUpdatedAt: null,
            items: resData.billTemplateDetails.map((item) => ({
              isFree: false,
              groupType: item.groupType,
              groupName: '',
              itemId: item.itemId,
              itemName: '',
              unitPrice: 0,
              quantity: item.quantity,
              discountOfPercent: item.discountOfPercent,
              nonTaxable: item.nonTaxable,
            })),
            periodicBillId: null,
          };
        } else {
          this.billTemplateData = {
            billId: '',
            templateName: '',
            studentId: '',
            studentUserId: '',
            studentName: '(生徒氏名)',
            gradeYear: GradeYears.ElementarySchool1,
            billGradeYear: GradeYears.ElementarySchool1,
            title: '',
            billNo: '',
            billDate: null,
            billDateCreationMonth: null,
            billDateCreationDay: 1,
            billMessage: '',
            contactInfo: '',
            billType: BillTypes.None,
            billExplanation: '',
            billLimitDate: null,
            billLimitDateCreationMonth: null,
            billLimitDateCreationDay: 31,
            taxRate: 10,
            taxType: this.billSettings.taxType,
            taxRoundType: this.billSettings.taxRoundType,
            billStatus: BillStatusTypes.Unbilled,
            billStatusUpdatedAt: null,
            paymentStatus: PaymentStatusTypes.Unpaid,
            paymentStatusUpdatedAt: null,
            items: [],
            periodicBillId: null,
          } ;
        }
      } catch (error) {
        this.$router.push({ name: 'BillTemplateList' });
      }
    }
  }

  private deactivated() {
    this.$destroy();
  }

  private onCancel() {
    this.$router.push({ name: 'BillTemplateList' });
  }

  private onRegister() {
    (this.$refs.form as ElForm).validate(async (valid) => {
      const editValid = await (this.$refs.editor as BillEditor).validateBillData();
      if (valid && editValid) {
        if (this.isEdit) {
          await this.updateBill();
        } else {
          await this.createBill();
        }
      } else {
        this.$message.error('入力項目を確認してください。');
        return false;
      }
    });
  }

  private async createBill() {
    const bill = this.billTemplateData!;

    try {
      const req: BillTemplateRequest = {
        billTemplateId: null,
        templateName: bill.templateName,
        title: bill.title,
        billDateCreationMonth: bill.billDateCreationMonth,
        billDateCreationDay: bill.billDateCreationDay,
        billMessage: bill.billMessage,
        contactInfo: bill.contactInfo,
        billType: bill.billType,
        billExplanation: bill.billExplanation,
        billLimitDateCreationMonth: bill.billLimitDateCreationMonth,
        billLimitDateCreationDay: bill.billLimitDateCreationDay,
        taxRate: bill.taxRate,
        billTemplateDetails: bill.items.map((item) => ({
          seq: 0,
          sort: 0,
          groupType: item.groupType,
          itemId: item.itemId,
          quantity: item.quantity,
          discountOfPercent: item.discountOfPercent,
          nonTaxable: item.nonTaxable,
        })),
      };
      const res = await Axios.post('/api/bill-templates/create', req);
      if (res.status === 200) {
        this.$notify.success({
          title: '請求書テンプレート作成',
          message: '請求書テンプレートを作成しました',
          position: 'bottom-right'
        });
        this.$router.push({ name: 'BillTemplateList' });
      }
    } catch (error) {
      this.$notify.error({
        title: '請求書テンプレート作成エラー',
        message:
          (error.response && error.response.data) || '請求書テンプレートの作成が失敗しました。',
        position: 'bottom-right'
      });
    }
  }

  private async updateBill() {
    try {
      const bill = this.billTemplateData!;
      const req: BillTemplateRequest = {
        billTemplateId: bill.billId,
        templateName: bill.templateName,
        title: bill.title,
        billDateCreationMonth: bill.billDateCreationMonth,
        billDateCreationDay: bill.billDateCreationDay,
        billMessage: bill.billMessage,
        contactInfo: bill.contactInfo,
        billType: bill.billType,
        billExplanation: bill.billExplanation,
        billLimitDateCreationMonth: bill.billLimitDateCreationMonth,
        billLimitDateCreationDay: bill.billLimitDateCreationDay,
        taxRate: bill.taxRate,
        billTemplateDetails: bill.items.map((item) => ({
          seq: 0,
          sort: 0,
          groupType: item.groupType,
          itemId: item.itemId,
          quantity: item.quantity,
          discountOfPercent: item.discountOfPercent,
          nonTaxable: item.nonTaxable,
        })),
      };
      const res = await Axios.put(`/api/bill-templates/${bill.billId}`, req);
      if (res.status === 200) {
        this.$notify.success({
          title: '請求書テンプレート更新',
          message: '請求書テンプレートを更新しました',
          position: 'bottom-right'
        });
        this.$router.push({ name: 'BillTemplateList' });
      }
    } catch (error) {
      this.$notify.error({
        title: '請求書テンプレート更新エラー',
        message:
          (error.response && error.response.data) || '請求書テンプレートの更新が失敗しました。',
        position: 'bottom-right'
      });
    }
  }

  private async onDeleteBillTemplate() {
    try {
      await this.$confirm(
        '請求書テンプレートを削除します。よろしいですか？',
        '請求書削除',
        {
          confirmButtonText: '削除',
          cancelButtonText: 'キャンセル',
          type: 'info',
        }
      );
    } catch (error) {
      return;
    }

    try {
      await Axios.delete(`/api/bill-templates/${this.billTemplateData!.billId }`);

      this.$router.push({ name: 'BillTemplateList' });

      this.$notify.success({
        title: '請求書テンプレート削除完了',
        message: '請求書テンプレートを削除しました。',
        position: 'bottom-right',
      });
    } catch (error) {
      this.$notify.error({
        title: '請求書テンプレート削除エラー',
        message:
          (error.response && error.response.data) || '請求書テンプレートの削除が失敗しました。',
        position: 'bottom-right',
      });
    }
  }

}
